import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { userApiRepositoryBuilder } from './UserApi'

export const userApiRepository = () => {
  return userApiRepositoryBuilder({
    httpService: new AxiosHttpServiceBuilder()
  })
}
